module.exports = __webpack_public_path__ + "assets/pizza_mobile-301d1c.svg";